import React, {Component} from "react";
import {
    Button, Col,
    Drawer, Form,
    FormInstance, Input,
    Layout,
    message,
    Popconfirm,
    Popover, Radio, Row, Select,
    Space,
    Spin,
    Table,
    Tag,
    Typography,
    Dropdown,
    Menu
} from "antd";
import {AiReportProps, SourceReportProps, TaskProps} from "../model/aireport";
import {
    CarryOutOutlined,
    CopyOutlined,
    DeleteOutlined,
    EditOutlined,
    SaveOutlined,
    StopOutlined,
    ExclamationCircleOutlined
} from "@ant-design/icons";
import ReactDOM from "react-dom";
import moment from "moment";
import AxiosUtil from "../../../utils/AxiosUtil";

import DataUtil from "../../../utils/DataUtil";

import '../../css/inputter.less'

const { Content } = Layout;
const { TextArea } = Input;
const windowEventBind = false;

interface IProps {
    onClose: (reload: boolean) => void,
}

interface IState {
}

export default class AiInputForm extends Component<IProps, IState> {
    formRef = React.createRef<FormInstance>();
    state = {
        taskInfo: {} as TaskProps,

        dataYsybList: [] as any[],
        dataAiybList: [],
        dataCatalogTree: [],
        dataCatalogSub: [],

        showInputter: false,

        loadingYsyb: false,
        loadingAiyb: false,
        showLoading: false,
        aiReport: {} as AiReportProps
    }
    componentDidMount() {
        this.loadParamList();
        if(!windowEventBind){
            window.addEventListener('keydown',(e)=>{
                // console.log(e);
                if (e.key === "s" && e.ctrlKey) {
                    this.formRef.current!.submit();
                    e.preventDefault();
                }
            })
        }
    }

    render() {
        const isCheck = window.location.hash.includes('taskCheck')
        const columnsYsyb = [
            {title: "SID", key: "source_id", dataIndex: "source_id", width: 80},
            {title: "任务ID", key: "task_id", dataIndex: "task_id", width: 60},
            {title: "日期", key: "publish_date", dataIndex: "publish_date", width: 90},
            {title: "机构", key: "company_name", dataIndex: "company_name", width: 80},
            {title: "标题", key: "title", dataIndex: "title", ellipsis: true,
                render: (text: string, row: any) => (
                    <Typography.Link onClick={(e) => onClickYsyb(row)}>{text}</Typography.Link>
                )
            },
            {title: "状态", key: "param_name", dataIndex: "param_name", width: 60},
        ];
        const columnsAiyb = [
            {title: "ID", key: "id", dataIndex: "id", width: 80},
            {title: "来源", key: "company_name", dataIndex: "company_name", width: 100},
            {
                title: "标题", key: "title", dataIndex: "title", ellipsis: true,
                render: (text: string, row: AiReportProps) => (
                    <Popover title={row.title} content={row.content}>
                        <Typography.Link onDoubleClick={(e) => onClickAiyb_Edit(row)}>{text}</Typography.Link>
                    </Popover>
                )
            },
            {title: "大类", key: "catalog_1", dataIndex: "catalog_1", width: 100},
            {title: "小类", key: "catalog_2", dataIndex: "catalog_2", width: 120},
            {title: "主观", key: "is_subjective", dataIndex: "is_subjective", width: 80, align: 'center' as 'center',},
            {
                title: "编辑", key: "id", dataIndex: "id", width: 80, align: 'center' as 'center',
                render: (text: string, row: any) => (
                    <Button onClick={(e) => onClickAiyb_Edit(row)}
                            shape="circle"
                            size={'small'}
                            type={'link'} icon={<EditOutlined/>}
                            style={{height: "20px"}}
                    />
                )
            },
        ];

        const onClickYsyb = (row: SourceReportProps) => {
            this.fillForm_Init()
            // console.log('onSourceReportClick', row);
            const title = row.title;
            const invest_advice = row.invest_advice;
            const summary = row.summary;
            let summarys = summary.split('\n');
            ReactDOM.render(
                <div className='inputForm'>
                    <Tag color={'blue'} className={'text-tag'}>研报标题</Tag>
                    <div style={{fontWeight: 500}}>{title}</div>
                    <Tag color={'blue'} className={'text-tag'}>投资建议</Tag>
                    <div style={{fontWeight: 500}}>{invest_advice}</div>
                    <Tag color={'blue'} className={'text-tag'}>内容摘要</Tag>
                    {
                        summarys.map((txt: string, index: number) => {
                            return (
                                <div className={'text-line'} key={"summary" + index}>{txt}
                                    <Button type={'link'}
                                            onClick={(e) => onClickCopy(row, txt)}>
                                        <CopyOutlined/>复制</Button>
                                </div>)
                        })
                    }
                </div>
                , document.getElementById('ysyb_text')
            );

            this.formRef.current!.setFieldsValue({
                source_report: row.source_id,
                source_title: `${row.source_id} - ${row.company_name}：${row.title} (${row.publish_date.substr(0,10)})`,
            })
        };
        const onClickCopy = (row: SourceReportProps, txt: string) => {
            //document.getElementById("abc")!.innerHTML = txt.trim();
            this.formRef.current!.setFieldsValue({
                content: txt.trim(),
                source_report: row.source_id,
                source_title: `${row.source_id} - ${row.company_name}：${row.title} (${row.publish_date.substr(0,10)})`,
            })
        };
        const onChangeCatalog1 = (val: string) => {
            this.setState({
                // aiReport: {catalog_1: val, catalog_2: ''},
                dataCatalogSub: this.state.dataCatalogTree.filter((el) => {
                    // @ts-ignore
                    return el.param_name === val
                    // @ts-ignore
                })[0].children
            })
            this.formRef.current!.setFieldsValue({catalog_2: ''})
        };
        const onChangeCatalog2 = (val: string, record: any) => {
            // console.log(this.formRef.current)
            const code = record ? record.excode ? record.excode === "1" ? 1 : 0 : 0 : 0;
            // console.log(record, code)
            this.formRef.current!.setFieldsValue({is_subjective: code})
        }

        const onFinishAiForm = (values: any) => {
            if(!values.source_title) return message.error('来源不能为空，请检查后重试')
            let myAi: AiReportProps = values;
            myAi.publish_date = moment().format('YYYY-MM-DD');
            myAi.end_date = moment().format('YYYY-MM-DD');
            myAi.begin_date = moment().add(-90, 'days').format('YYYY-MM-DD');
            // console.log('Received values of form: ', myAi);

            this.setState({loadingAiyb: true});
            const postCallBack = (suc: boolean, dat: any) => {
                this.setState({loadingAiyb: false});
                if (suc) {
                    message.success({content:"保存完成！",className:'message_success'});
                    this.loadInputter_Ai(myAi.task_id);
                    this.fillForm_Init()
                }
            }
            AxiosUtil.AxiosRequest('/api/yb/updateAiReport', {list:[myAi]}, postCallBack);
        };

        // 开始编辑AI研报记录
        const onClickAiyb_Edit = (r: AiReportProps) => {
            this.setState({
                dataCatalogSub: this.state.dataCatalogTree.filter((el) => {
                    // console.log(el)
                    // @ts-ignore
                    return el.param_name === r.catalog_1
                    // @ts-ignore
                })[0].children
            })
            this.fillForm_AiReport(r);
        };
        // 删除AI研报记录
        const onClickAiyb_Del = () => {
                this.setState({loadingAiyb: true});
                const postCallBack = (suc: boolean, dat: any) => {
                this.setState({loadingAiyb: false});
                if (suc) {
                    message.success({content:"删除完成！",className:'message_success'});
                    this.loadInputter_Ai(this.state.taskInfo.id);
                    this.fillForm_Init()
                }
            }
            if (this.state.aiReport.id !== 0) {
                AxiosUtil.AxiosRequest('/api/yb/updateAiReport', {list: [{id: this.state.aiReport.id, isDelete: 1}]}, postCallBack);
            }
        };
        // 2: 已完成; 11: 无需处理
        type status = 2 | 11
        // 完成本次AI研报任务
        const onFinishAiReport = (status: status) => {
            this.setState({showLoading: true})
            const postCallBack = (suc: boolean, dat: any) => {
                this.setState({loadingAiyb: false, showLoading: false});
                if (suc) {
                    status === 2
                    ? message.success({content:"任务已完成！",className:'message_success'})
                    : message.success({content: '已设为"无需处理"状态'})
                    this.setState({showInputter: false});
                    // this.setState({showInputter: false, isIgnore: false});
                    this.props.onClose(true);
                }
            }
            //const login_info = store.get('login_info');
            const queryParam = {
                taskStatus: status,
                taskId: this.state.taskInfo.id,
                ybIdList: this.state.dataYsybList.map((r: SourceReportProps) => (r.source_id)),
                //user_id: login_info.user_id
            }
            AxiosUtil.AxiosRequest('/api/ybTask/upReportStatus', queryParam, postCallBack);
        }

        // "研报完成"旁的隐藏按钮
        const actionSubMenu = (
            <Menu >
                <Popconfirm
                    title='确定把该任务设为"无需处理"吗？'
                    onConfirm={()=>{onFinishAiReport(11)}}
                    okText="确定"
                    cancelText='再看看'
                >
                    <Menu.Item key='ignore' icon={<ExclamationCircleOutlined />} style={{color: "red"}}>无需处理</Menu.Item>
                </Popconfirm>
            </Menu>
        );

        return (
            <Drawer title={
                <div className={'dialog-title'}>
                    <Space className='grey'>
                        <EditOutlined/> 研报录入：
                        <span className="blue">{this.state.taskInfo.id}</span>  /
                        <span className='blue'>{this.state.taskInfo.security_name} （{this.state.taskInfo.symbol}）</span> /
                        <span className='normal'>{this.state.taskInfo.userName}</span>  /
                        {this.state.taskInfo.taskDay}
                    </Space>
                    <div className={'flex-blank'} />
                    <Space className={'right'}>
                        <Spin size="small" spinning={this.state.showLoading}>
                            {<Popconfirm
                                title="确定本次任务研报记录已经全部完成了吗？"
                                onConfirm={()=>{onFinishAiReport(2)}}
                                disabled={this.state.taskInfo.taskStatus !== 1}
                                okText="确定完成"
                                cancelText='再看看'
                            >
                                <Dropdown.Button key="drop"
                                    type="primary"
                                    disabled={this.state.taskInfo.taskStatus !== 1}
                                    overlay={actionSubMenu}>
                                    <CarryOutOutlined/> 研报完成
                                </Dropdown.Button>
                            </Popconfirm>}
                        </Spin>
                    </Space>
                </div>
            }
                    forceRender={true}
                    placement="right"
                    width={'100%'}
                    visible={this.state.showInputter}
                    onClose={this.closeInputter}
                    className='inputter_window'
            >
                <Content id='inputter_container'>
                    <Layout className={'inputter_layout inputter_left'} >
                        <Spin tip="Loading..." size="large" spinning={this.state.loadingYsyb}>
                            <Table key="Ysyb"
                                   rowKey="id"
                                   size="small"
                                   pagination={{pageSize: 5}}
                                   columns={columnsYsyb}
                                   dataSource={this.state.dataYsybList}
                                   bordered
                            />
                            <div id={'ysyb_text'} />
                            <div style={{height: '128px'}} />
                        </Spin>
                    </Layout>
                    <Layout className={'inputter_layout inputter_right'} >
                        <Spin tip="Loading..." size="large" spinning={this.state.loadingAiyb}>
                            <Table key="Aiyb"
                                   rowKey="id"
                                   size="small"
                                   pagination={false}
                                   columns={columnsAiyb}
                                   dataSource={this.state.dataAiybList}
                                   scroll={{y:195}}
                                   bordered
                            />
                            <span className={"right"}>已录入{this.state.dataAiybList.length}条</span>
                            <div className='line-blank' />
                            <div className="inputForm">
                                <Form name="AiReport_Form"
                                      layout="horizontal"
                                      colon={false}
                                      onFinish={onFinishAiForm}
                                      labelCol={{span: 3, offset: 0}}
                                      ref={this.formRef}
                                >
                                    <Form.Item hidden name={'id'} initialValue={0}><Input /></Form.Item>
                                    <Form.Item hidden name={'task_id'} initialValue={0}><Input /></Form.Item>
                                    <Form.Item hidden name={'symbol'}><Input /></Form.Item>
                                    <Form.Item hidden name={'security_name'}><Input /></Form.Item>
                                    <Form.Item hidden name={'security_code'}><Input /></Form.Item>
                                    <Form.Item hidden name={'source_report'}><Input /></Form.Item>
                                    <Row gutter={[0, 0]}>
                                        <Col span={3} style={{textAlign: 'right', padding: 16}}>ID</Col>
                                        <Col span={21} style={{ padding: 16}}>
                                            {this.state.aiReport.id===0?
                                                <span className='grey'>新增</span>
                                                :
                                                <span className='blue'>{this.state.aiReport.id}</span>
                                            }
                                        </Col>
                                        {/* <Col span={21} style={{ padding: 16}}>
                                            {this.state.aiReport.id===0
                                                ? <span className='grey'>新增：</span>
                                                : <div>ID：<span className='blue'>{this.state.aiReport.id}</span></div>
                                            }
                                        </Col> */}
                                        <Col span={24}>
                                            <Form.Item name={'title'} label={'标题'}
                                                       rules={[{required: true, message: '请输入标题'}]}>
                                                <Input placeholder={'请输入标题'} autoComplete="off" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item name={'catalog_1'}  label={'大类'} labelCol={{span: 6, offset: 0}}
                                                       rules={[{required: true, message: '请选择大类'}]}>
                                                <Select onChange={onChangeCatalog1}>
                                                    {DataUtil.selectOptionsRender(this.state.dataCatalogTree, 'param_name', 'param_name')}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item name={'catalog_2'}  label={'小类'} labelCol={{span: 6, offset: 0}}
                                                       rules={[{required: true, message: '请选择小类'}]}>
                                                <Select onChange={onChangeCatalog2}>
                                                    {this.formRef.current?.getFieldValue("catalog_1") ? DataUtil.selectOptionsRender(this.state.dataCatalogSub, 'param_name', 'param_name','param_code'):[]}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item name={'content'} label={'内容'}>
                                                <TextArea rows={5} value='' autoComplete='off' />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item name={'source_title'} label={'来源'}>
                                                <Input readOnly={true} bordered={false} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={4} />
                                        <Col span={8}>
                                            <Form.Item name={'is_subjective'} initialValue={0}>
                                                <Radio.Group>
                                                    <Radio value={1}>1-主观</Radio>
                                                    <Radio value={0}>0-客观</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12} >
                                            <Form.Item>
                                                <Space  className={'right'}>
                                                    <Button className="login-form-button"
                                                            onClick={this.fillForm_Init}
                                                            icon={<StopOutlined/>}>
                                                        取消
                                                    </Button>
                                                    {/* {console.log(this.state.taskInfo)} */}
                                                    <Popconfirm
                                                        title={`本研报任务当前状态为 "${this.state.taskInfo.param_name}" , 您确认要修改吗?`}
                                                        // onVisibleChange={() => console.log('visible change')}
                                                        okText="确认"
                                                        onConfirm={()=>{
                                                            // isCheck ?
                                                            this.formRef.current?.submit()
                                                            // : message.warning('您非审核人员, 无权限操作该状态任务!')
                                                        }}
                                                        disabled={this.state.taskInfo.taskStatus === 1 }
                                                        // disabled={this.state.taskInfo.taskStatus === 1 || this.state.taskInfo.taskStatus === 11 || this.state.taskInfo.taskStatus === 12}
                                                    >
                                                        <Button
                                                            type="primary"
                                                            className="login-form-button"
                                                            onClick={()=>{
                                                            console.log(this.state.taskInfo.taskStatus)
                                                            if(this.state.taskInfo.taskStatus === 1) this.formRef.current?.submit()
                                                            }}
                                                            // disabled={this.state.taskInfo.taskStatus === 11 || this.state.taskInfo.taskStatus === 12}
                                                            icon={<SaveOutlined/>}
                                                        >
                                                            保存
                                                        </Button>
                                                    </Popconfirm>
                                                    <Popconfirm
                                                        placement="topLeft"
                                                        title={() => {
                                                            if(this.state.taskInfo.taskStatus === 0 || this.state.taskInfo.taskStatus === 1)
                                                                return `确定要删除这条研报记录吗？`
                                                            // console.log(this.state.taskInfo)
                                                            return `本研报任务当前状态为 "${this.state.taskInfo.param_name}" ，您确认要删除吗？`
                                                        }}
                                                        onConfirm={() => {
                                                            // if(this.state.taskInfo.taskStatus === 1)
                                                                onClickAiyb_Del()
                                                            // else isCheck ? onClickAiyb_Del() : message.warning('您非审核人员, 无权限操作该状态任务!')
                                                        }}
                                                        okText="删除"
                                                        disabled={this.state.aiReport.id === 0 }
                                                        // disabled={this.state.aiReport.id === 0 || this.state.taskInfo.taskStatus === 11 || this.state.taskInfo.taskStatus === 12}
                                                    >
                                                        <Button danger
                                                                disabled={this.state.aiReport.id === 0 }
                                                                // disabled={this.state.aiReport.id === 0 || this.state.taskInfo.taskStatus === 11 || this.state.taskInfo.taskStatus === 12}
                                                                icon={<DeleteOutlined/>}>
                                                            删除</Button>
                                                    </Popconfirm>
                                                </Space>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                            <div style={{height: '128px'}} />
                        </Spin>
                    </Layout>
                </Content>
            </Drawer>

        )
    }

    openInputter = (task: TaskProps) => {
        //console.log('onInputClick', task);
        //if (this.state.taskInfo.symbol !== task.symbol) {
            this.loadInputter_Ys(task.symbol);
            this.loadInputter_Ai(task.id);
        //}
        this.setState({
            showInputter: true,
            taskInfo: task
        });
        this.fillForm_Init1(task);
    };
    closeInputter = () => {
        this.setState({showInputter: false});
        // this.setState({showInputter: false, isIgnore: false});
        this.props.onClose(true);
    };
    fillForm_AiReport = (myAi: AiReportProps) => {
        let source_title = "";
        try {
            source_title= `${myAi.source_report} - ${myAi.company_name}：${myAi.rp_title} (${myAi.rp_publish_date.substr(0, 10)})`;
        }catch {}

        this.formRef.current!.setFieldsValue({...myAi, source_title: source_title});
        this.setState({aiReport: myAi});
    }
    fillForm_Init = () => {
        this.fillForm_Init1(this.state.taskInfo);

    }
    fillForm_Init1 = (myTask: TaskProps ) => {
        let myAi = {} as AiReportProps;
        myAi.id = 0;
        myAi.task_id = myTask.id;
        myAi.symbol = myTask.symbol;
        myAi.security_name = myTask.security_name;
        myAi.security_code = myTask.security_code;
        myAi.catalog_1 = ""
        myAi.catalog_2 = ""
        myAi.title = ""
        myAi.content = "";
        //myAi.source_report = this.formRef.current?.getFieldsValue().source_report;
        this.fillForm_AiReport(myAi);
    }

    loadParamList = () => {
        const dataCatalog = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({dataCatalogTree: dat[0].children});
            }
        }
        AxiosUtil.AxiosRequest('/api/param/tl', {parent_id: 181}, dataCatalog);
    }
    // 读取录入所需信息：原始研报
    loadInputter_Ys = ( symbol: String) => {
        this.setState({loadingYsyb: true});
        const dataYsyb = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({dataYsybList: dat.ybList});
                ReactDOM.render(<></>, document.getElementById('ysyb_text'))
            }
            this.setState({loadingYsyb: false});
        }
        AxiosUtil.AxiosRequest('/api/yb/getYbInfo', {'pageSize':9999 ,'symbol': symbol}, dataYsyb);
    }
    // 读取录入所需信息：已录入研报
    loadInputter_Ai = (task_id: number) => {
        this.setState({loadingAiyb: true});
        const dataAiyb = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({dataAiybList: dat.list});
            }
            this.setState({loadingAiyb: false});
        }
        AxiosUtil.AxiosRequest('/api/yb/getAiReport', {'task_id': task_id}, dataAiyb);
    }
}